/* DRG CUSTOM (START) 20260519 | IDEAL drawer swipe architecture */

document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('#Details-menu-drawer-container');
  const summary = container?.querySelector('summary');
  const drawer = document.querySelector('#menu-drawer');

  if (!container || !summary || !drawer) return;

  /* =========================
     MOVE WHOLE DRAWER (NOT INNER)
  ========================= */

  const panel = drawer; // ←ここが理想形の本質

  const SWIPE = {
    threshold: 70,
    lockThreshold: 10,
    returnDuration: 180
  };

  let startX = 0;
  let startY = 0;
  let currentX = 0;
  let dragging = false;
  let lockAxis = null;
  let isClosingBySwipe = false;

  const root = document.documentElement;

  function isOpen() {
    return container.hasAttribute('open');
  }

  function setTranslate(x, animate = false) {
    panel.style.transition = animate
      ? `transform ${SWIPE.returnDuration}ms ease`
      : 'none';

    panel.style.transform = `translate3d(${x}px,0,0)`;
  }

  function resetDrawer(animate = false) {
    setTranslate(0, animate);

    if (animate) {
      setTimeout(() => {
        panel.style.transition = '';
      }, SWIPE.returnDuration + 20);
    } else {
      panel.style.transition = '';
    }
  }

  function cleanupAfterClose() {
    panel.style.transform = '';
    panel.style.transition = '';

    root.classList.remove('drg-drawer-open');

    void document.body.offsetWidth;
  }

  function openState() {
    root.classList.add('drg-drawer-open');
  }

  function closeState() {
    root.classList.remove('drg-drawer-open');
  }

  function closeDrawerProperly() {
    isClosingBySwipe = true;

    const width = panel.getBoundingClientRect().width;

    setTranslate(width, true);

    setTimeout(() => {
      if (isOpen()) summary.click();

      setTimeout(() => {
        cleanupAfterClose();
        isClosingBySwipe = false;
      }, 50);
    }, SWIPE.returnDuration);
  }

  function canStartSwipe(target) {
    if (!isOpen()) return false;
    if (!target) return false;

    if (
      target.closest('a') ||
      target.closest('button') ||
      target.closest('input') ||
      target.closest('select') ||
      target.closest('textarea') ||
      target.closest('label')
    ) {
      return false;
    }

    return !!target.closest('#menu-drawer');
  }

  /* =========================
     TOUCH HANDLING
  ========================= */

  drawer.addEventListener('touchstart', (e) => {
    if (!e.touches || e.touches.length !== 1) return;
    if (!canStartSwipe(e.target)) return;

    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;

    currentX = 0;
    dragging = true;
    lockAxis = null;

    panel.style.transition = 'none';
  }, { passive: true });

  drawer.addEventListener('touchmove', (e) => {
    if (!dragging || !isOpen()) return;
    if (!e.touches || e.touches.length !== 1) return;

    const dx = e.touches[0].clientX - startX;
    const dy = e.touches[0].clientY - startY;

    const absX = Math.abs(dx);
    const absY = Math.abs(dy);

    if (lockAxis === null) {
      if (absX < SWIPE.lockThreshold && absY < SWIPE.lockThreshold) return;
      lockAxis = absX > absY ? 'x' : 'y';
    }

    if (lockAxis !== 'x') return;

    if (dx > 0) {
      currentX = dx;
      setTranslate(dx, false);
      e.preventDefault();
    }
  }, { passive: false });

  function endSwipe() {
    if (!dragging) return;

    dragging = false;

    if (lockAxis !== 'x') {
      resetDrawer(false);
      return;
    }

    if (currentX >= SWIPE.threshold) {
      closeDrawerProperly();
    } else {
      resetDrawer(true);
    }

    currentX = 0;
    lockAxis = null;
  }

  drawer.addEventListener('touchend', endSwipe, { passive: true });
  drawer.addEventListener('touchcancel', endSwipe, { passive: true });

  /* =========================
     STATE SYNC (IMPORTANT)
  ========================= */

  container.addEventListener('toggle', () => {
    if (isClosingBySwipe) return;

    requestAnimationFrame(() => {
      if (isOpen()) {
        resetDrawer(false);
        openState();   // ←ここだけで管理
      } else {
        cleanupAfterClose();
        closeState();
      }
    });
  });

  /* =========================
     CLICK CLOSE
  ========================= */

  drawer.addEventListener('click', (e) => {
    if (e.target.closest('a')) {
      resetDrawer(false);

      setTimeout(() => {
        if (!isOpen()) cleanupAfterClose();
      }, 50);
    }
  });
});

/* DRG CUSTOM (END) 20260519 | IDEAL drawer swipe architecture */